export enum UserRoles {
	ADMIN = 'admin',
	DISPATCH_CENTER = 'dispatch_center',
	VACCINATION_CENTER = 'vaccination_center',
	VACCINATION_POINT = 'vaccination_point',
	ADMIN_DISPATCH = 'admin_dispatch',
	ADMIN_ZONE = 'admin_zone',
	REFERENT = 'referent',
}